import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { LoaderService } from "@app/services/loader.service";

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit {

  public sidebarIsOpen: boolean = true;

  constructor(
      @Inject(DOCUMENT) private document: Document,
      private renderer: Renderer2,
      public loaderService: LoaderService) { }

  ngOnInit(): void {
    const smode = localStorage.getItem('smode');
    if (smode === 'closed') {
      this.toggleSidebar();
    }
    else {
      this.sidebarIsOpen = true;
    }
  }

  toggleSidebar() {
    if (this.sidebarIsOpen) {
      this.renderer.addClass(this.document.body, 'sidebar-collapse');
      this.sidebarIsOpen = false;
      localStorage.setItem('smode', 'closed');
    }
    else {
      this.renderer.removeClass(this.document.body, 'sidebar-collapse');
      this.sidebarIsOpen = true;
      localStorage.setItem('smode', 'open');
    }
  }
}
